import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { EditorComponent } from '@progress/kendo-angular-editor';
interface Item {
  text: string;
  size: number;
}
@Component({
  selector: 'tyl-kendo-html-editor',
  templateUrl: './tyl-kendo-html-editor.component.html'
})

export class TylKendoHtmlEditorComponent implements OnInit {
  @Input() inputValue: string;
  @Output() myOutput: EventEmitter<string> = new EventEmitter();
  @ViewChild('editor', { static: true }) editor: EditorComponent;
  @Output() focus: EventEmitter<boolean> = new EventEmitter();
  public value = `
  `;

  public listItems: Array<Item> = [
    { text: '8pt', size: 10.664 },
    { text: '9pt', size: 11.997 },
    { text: '10pt', size: 13.33 },
    { text: '11pt', size: 14.663 },
    { text: '12pt', size: 15.996 },
    { text: '14pt', size: 18.662 },
    { text: '16pt', size: 21.328 },
    { text: '18pt', size: 23.994 },
    { text: '20pt', size: 26.66 },
    { text: '22pt', size: 29.326 },
    { text: '24pt', size: 31.992 },
    { text: '26pt', size: 34.658 },
    { text: '28pt', size: 37.324 },
    { text: '36pt', size: 47.988 },
    { text: '48pt', size: 63.984 },
    { text: '72pt', size: 95.976 }
  ];

  public selectedItem: Item = this.listItems[1];
  constructor() { }

  ngOnInit(): void {
  }

  saveClick() {
    this.myOutput.emit(this.inputValue);
  }

  onFocus() {
    this.focus.emit();
  }

}